<template>
  <egg-label-list
    title="tpa.tpaBenefit"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleLeft', imgFormat: 'svg', position: 'top:50%' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="tpaStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useTpaStore } from "@/stores/tpa";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const tpaStore = useTpaStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>